export default "__VITE_ASSET__BG4SCHBY__"